import script from "./PhoneView.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneView.vue?vue&type=script&setup=true&lang=js"

import "./PhoneView.vue?vue&type=style&index=0&id=1b5edda6&lang=less"

const __exports__ = script;

export default __exports__